import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";
import { CalendarCheck, ArrowRight } from "@phosphor-icons/react";

const iso = (d) => d.toISOString().slice(0, 10);

// Dashboard: Übergaben/Rücknahmen der nächsten 14 Tage
export default function UpcomingHandovers() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const now = new Date();
    api.get("/handover-appointments", { params: { date_from: iso(now), date_to: iso(new Date(now.getTime() + 14 * 864e5)) } })
      .then(({ data }) => setItems(data || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <div className="bg-white border border-teal-200 rounded-md overflow-hidden" data-testid="dashboard-upcoming-handovers">
      <div className="flex items-center gap-2 px-4 py-2 border-b border-teal-100 bg-teal-50/60">
        <CalendarCheck size={16} className="text-teal-800" />
        <h2 className="text-sm font-semibold text-teal-900">Nächste Übergaben & Rücknahmen</h2>
        <span className="text-xs text-teal-800">{items.length} in den nächsten 14 Tagen</span>
        <Link to="/uebergabetermine" className="ml-auto text-xs font-medium text-teal-800 hover:text-teal-950 inline-flex items-center gap-1" data-testid="upcoming-handovers-all">Kalender <ArrowRight size={12} /></Link>
      </div>
      <div className="divide-y divide-slate-100 max-h-56 overflow-y-auto">
        {items.slice(0, 8).map((it) => (
          <Link key={`${it.tenancy_id}-${it.kind}`} to={`/mietverhaeltnisse/${it.tenancy_id}?tab=protocols`} className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-slate-50" data-testid={`upcoming-handover-${it.tenancy_id}-${it.kind}`}>
            <span className="text-xs w-32 shrink-0 tabular-nums">{formatDate(it.date)}{it.time ? `, ${it.time}` : ""}</span>
            <span className={`text-[10px] uppercase tracking-wider font-semibold w-20 shrink-0 ${it.kind === "in" ? "text-emerald-700" : "text-amber-700"}`}>{it.kind === "in" ? "Übergabe" : "Rücknahme"}</span>
            <span className="text-xs w-44 shrink-0 truncate text-slate-700">{it.tenants.join(", ") || it.contract_number}</span>
            <span className="flex-1 text-xs truncate text-slate-600">{it.location}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
